import mixpanel from "mixpanel-browser";
import { https } from "../http";
import store from "../store";
import {
  _login,
  setEmailVerifyLoading,
  setLoading,
  setForgotLoading,
  setResetLoading,
  setContactUs,
} from "../store/reducers/auth";
import {
  removeCookie,
  setCookie,
  showError,
  showInfo,
  showSuccess,
} from "../utils/index";
import { getProfile } from "./profile";
import swal from "sweetalert";
import { userInfoAnalytics } from "../config/mixpanelConfig";
import { getAllStaff } from "./staff";

// const login = async (values, navigate) => {
//   try {
//     store.dispatch(setLoading(true));
//     let response = await https().post("/auth/login", values);
//     console.log("🚀 ~ login ~ response:", response)
//     const { message, token, user } = response?.data;
//     console.log("🚀 ~ login ~ token:", token)
//     let profile = await getProfile(true, response?.data?.token);
//     console.log("🚀 ~ login ~ profile:", profile)

//     if (response?.status === 200) {
//       if (message === "Email Verified") {
//         if (token) {
//           if (profile.user?.user?.type !== "staff") {
//             setCookie(token, "token");
//             if (!profile?.user?.business) {
//               navigate("/signup", { state: { token: token } });
//               // navigate("/selectprice");
//             } else if (profile.user.business && !profile.user.subscription) {
//               navigate("/selectprice");
//             } else {
//               navigate("/home");
//             }
//           } else if (
//             profile?.user?.user?.type === "staff"
//           ) {
//             navigate("/select-busniesses", { state: { res: response.data.user.user } });
//           }
//           // else {
//           //   setCookie(token, "token");
//           //   navigate("/home");
//           // }
//           store.dispatch(_login({ token }));
//         } else {
//           navigate("/select-2fa-method", {
//             state: { user: response.data.user },
//           });
//           store.dispatch(_login({ token }));
//         }
//       } else if (message === "Verification Email Sent") {
//         showInfo("Verification Email Sent");
//       }
//       store.dispatch(setLoading(false));

//       // let profile = await getProfile(true, response?.data?.token);
//       // if (profile) {
//       //   userInfoAnalytics(profile);
//       //   let { token, user, message } = response?.data;
//       //   if (message === "Email Verified") {
//       //     setCookie(token, "token");
//       //     if (user?.user?.type !== "staff") {
//       //       // console.log("user", user);
//       //       if (user?.business) {
//       //         // navigate("/selectprice");
//       //       } else if (!user?.business) {
//       //         // navigate("/profile");
//       //         navigate("/signup", { state: { token: token } });
//       //       } else if (user?.business && user?.subscription) {
//       //         navigate("/select-2fa-method");
//       //       }
//       //     } else navigate("/select-2fa-method");
//       //     store.dispatch(_login({ token }));
//       //   } else if (message === "Verification Email Sent") {
//       //     showInfo("Verification Email Sent");
//       //   }
//       // }
//       // let profile = await getProfile(true, response?.data?.token);
//       // if (profile) {
//       //   // console.log("profile on login", profile)
//       //   // mixpanel.identify(profile?.user?.user?.id);
//       //   // mixpanel.people.set({
//       //   //   $name: profile?.user?.user?.name,
//       //   //   $email: profile?.user?.user?.email,
//       //   //   $avatar: profile?.user?.user?.photo,
//       //   // });
//       //   userInfoAnalytics(profile);
//       //   let { token, user, message } = response?.data;
//       //   if (message === "Email Verified") {
//       //     setCookie(token, "token");
//       //     if (profile?.user?.user?.type !== "staff") {
//       //       // console.log("user", user);
//       //       if (profile?.user?.business) {
//       //         // navigate("/selectprice");
//       //       } else if (!profile?.user?.business) {
//       //         // navigate("/profile");
//       //         navigate("/signup", { state: { token: token } });
//       //       } else if (profile?.user?.business && profile?.user?.subscription) {
//       //         if (profile?.user?.user?.twoFactorType) {
//       //           navigate("/2fa");
//       //         } else {
//       //           navigate("/select-2fa-method");
//       //         }
//       //       }
//       //     } else
//       //       profile?.user?.user?.twoFactorType
//       //         ? navigate("/2fa")
//       //         : navigate("/select-2fa-method");
//       //     store.dispatch(_login({ token }));
//       //   } else if (message === "Verification Email Sent") {
//       //     showInfo("Verification Email Sent");
//       //   }
//       // }
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status, false);
//   }
// };

const login = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/login", values);
    // console.log("🚀 ~ login ~ response:", response);
    const { message, token, user } = response?.data;
    let profile = await getProfile(true, response?.data?.token);
    // console.log("🚀 ~ login ~ profile:", profile);
    // const isFreeAccount =
    //   profile?.user?.subscription?.packageId?.name === "Free"
    //     ? profile?.user?.subscription?.packageId?.name === "Free"
    //     : profile?.isFreeAccount === true;
    // console.log("🚀 ~ login ~ isFreeAccount:", isFreeAccount);

    if (response?.status === 200) {
      if (message === "Email Verified") {
        //Check if token exists (From backend token will be sent only when 2FA is not enabled)
        if (token) {
          store.dispatch(_login({ token }));
          // If token is true then check user type
          if (profile.user?.user?.type !== "staff") {
            if (user?.is2FaAccess === true && token) {
              navigate("/select-2fa-method", {
                state: { user: user },
              });
              return; // ← Exits here if 2FA is enabled
            }

            // If user type is admin then set the token and move forward
            setCookie(token, "token");

            // free account redirect to select price page if user is admin
            if (profile?.isFreeAccount) {
              navigate("/selectprice", {
                state: { isFreeAccount: true },
              });
              return;
            }

            if (!profile?.user?.business) {
              navigate("/signup", {
                state: {
                  token: token,
                  businessName: response?.data?.user?.businessName,
                },
              });
              // navigate("/selectprice");
            } else if (profile.user.business && !profile.user.subscription) {
              navigate("/selectprice");
            } else if (profile?.isFreeAccount) {
              navigate("/selectprice", {
                state: { isFreeAccount: true },
              });
            } else {
              navigate("/home");
            }
          } else if (profile?.user?.user?.type === "staff") {
            if (profile?.isFreeAccount) {
              navigate("/free-plan-users");
              return;
            }
            if (user?.user?.is2FaAccess === true && token) {
              navigate("/select-2fa-method", {
                state: { user: user?.user },
              });
              return;
            }
            // If user type is staff then check if staff has multiple businesses
            if (response.data?.user?.user?.businesses?.length > 1) {
              // If staff has multiple businesses then navigate to select businesses page
              navigate("/select-busniesses", {
                state: { res: response.data.user.user },
              });
            } else {
              // If staff has single business then set the token and move to dashboard
              setCookie(token, "token");
              navigate("/home");
            }
          }
        } else {
          // If token is not present then check the user type
          if (response?.data.user?.user?.type !== "staff") {
            // If user type is admin then navigate to 2fa screen
            navigate("/ ", {
              state: { user: response.data.user },
            });
          } else {
            // If user type is staff then check if staff has multiple businesses
            if (response.data?.user?.user?.businesses?.length > 1) {
              // If staff has multiple businesses then navigate to select businesses page
              navigate("/select-busniesses", {
                state: { res: response.data.user.user },
              });
            } else {
              // If staff has single business then navigate to 2fa screen
              navigate("/select-2fa-method", {
                state: { user: response?.data?.user?.user },
              });
            }
          }
          // store.dispatch(_login({ token }));
        }
      } else if (message === "Verification Email Sent") {
        showInfo("Verification Email Sent");
      }
      store.dispatch(setLoading(false));

      // let profile = await getProfile(true, response?.data?.token);
      // if (profile) {
      //   userInfoAnalytics(profile);
      //   let { token, user, message } = response?.data;
      //   if (message === "Email Verified") {
      //     setCookie(token, "token");
      //     if (user?.user?.type !== "staff") {
      //       // console.log("user", user);
      //       if (user?.business) {
      //         // navigate("/selectprice");
      //       } else if (!user?.business) {
      //         // navigate("/profile");
      //         navigate("/signup", { state: { token: token } });
      //       } else if (user?.business && user?.subscription) {
      //         navigate("/select-2fa-method");
      //       }
      //     } else navigate("/select-2fa-method");
      //     store.dispatch(_login({ token }));
      //   } else if (message === "Verification Email Sent") {
      //     showInfo("Verification Email Sent");
      //   }
      // }
      // let profile = await getProfile(true, response?.data?.token);
      // if (profile) {
      //   // console.log("profile on login", profile)
      //   // mixpanel.identify(profile?.user?.user?.id);
      //   // mixpanel.people.set({
      //   //   $name: profile?.user?.user?.name,
      //   //   $email: profile?.user?.user?.email,
      //   //   $avatar: profile?.user?.user?.photo,
      //   // });
      //   userInfoAnalytics(profile);
      //   let { token, user, message } = response?.data;
      //   if (message === "Email Verified") {
      //     setCookie(token, "token");
      //     if (profile?.user?.user?.type !== "staff") {
      //       // console.log("user", user);
      //       if (profile?.user?.business) {
      //         // navigate("/selectprice");
      //       } else if (!profile?.user?.business) {
      //         // navigate("/profile");
      //         navigate("/signup", { state: { token: token } });
      //       } else if (profile?.user?.business && profile?.user?.subscription) {
      //         if (profile?.user?.user?.twoFactorType) {
      //           navigate("/2fa");
      //         } else {
      //           navigate("/select-2fa-method");
      //         }
      //       }
      //     } else
      //       profile?.user?.user?.twoFactorType
      //         ? navigate("/2fa")
      //         : navigate("/select-2fa-method");
      //     store.dispatch(_login({ token }));
      //   } else if (message === "Verification Email Sent") {
      //     showInfo("Verification Email Sent");
      //   }
      // }
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

const send2faCode = async (values, navigate) => {
  try {
    let response = await https().post("/auth/send-2fa", values);
    if (response?.status === 200) {
      showInfo(response?.data?.message || "");
      navigate("/2fa", {
        state: { user: response.data.user },
      });
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const verify2fa = async (values, navigate) => {
  try {
    let response = await https().post("/auth/verify-2fa", values);
    console.log("🚀 ~ verify2fa ~ response:", response);
    if (response?.status === 200) {
      // if (profile) {
      let { token, user, message } = response?.data;
      console.log("🚀 ~ verify2fa ~ user:", user);
      console.log("🚀 ~ verify2fa ~ token:", token);
      let profile = await getProfile(true, response?.data?.token);
      if (token) {
        userInfoAnalytics(profile);
        if (profile.user?.user?.type !== "staff") {
          setCookie(token, "token");
          if (!profile?.user?.business) {
            navigate("/signup");
            // navigate("/selectprice");
          } else if (profile.user.business && !profile.user.subscription) {
            navigate("/selectprice");
          } else {
            navigate("/home");
          }
        } else {
          navigate("/home");
          setCookie(token, "token");
        }
        // else navigate("/select-2fa-method");
        store.dispatch(_login({ token }));
      }
      // else if (
      //   user?.type === "staff" &&
      //   user?.businessId
      // ) {
      //   navigate("/select-busniesses", { state: { res: user } });
      // }
      else {
        navigate("/home");
      }
      // else {
      //   // navigate("/select-busniesses", { state: { response } });
      //    setTimeout(() => {
      //     navigate("/select-busniesses", { state: { response } });
      //   }, 100);
      //   return response?.data;
      // }
      // }
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
    if (
      resData?.user &&
      resData?.user?.lockUntil &&
      new Date(resData.user.lockUntil) > new Date()
    ) {
      navigate("/login", { replace: true });
    }
  }
};

const resetStaff2FA = async (values, navigate) => {
  try {
    let response = await https().post("/auth/reset-staff-2fa", values);
    if (response?.status === 200) {
      // let profile = await getProfile(true, response?.data?.token);
      getAllStaff("all");
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
  }
};
const staffAndProfile2fa = async (values, navigate) => {
  try {
    let response = await https().post("/auth/staff-profile-verify-2fa", values);
    if (response?.status === 200) {
      // let profile = await getProfile(true, response?.data?.token);
      getAllStaff("all");
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
  }
};

const resend2fa = async (values) => {
  try {
    let response = await https().post("/auth/resend-code", values);
    if (response?.status === 200) {
      showSuccess(response?.data?.message);
      return response?.data;
    }
  } catch (error) {
    showError(
      error?.response?.data?.error || error?.response?.data?.message,
      error?.response?.status
    );
  }
};

const verifyTwoFactor = async (values) => {
  try {
    let response = await https().post("/auth/verify-two-factor", values);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};

const twoFactorSettings = async (values) => {
  try {
    let response = await https().post("/auth/two-factor-settings", values);
    if (response?.status === 200) {
      getProfile();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};
const selectedBusiness = async (values) => {
  try {
    let response = await https().post("/auth/selected-business", values);
    if (response?.status === 200) {
      // getProfile();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};
const getUserByEmail = async (values) => {
  try {
    let response = await https().post("/auth/get-user-by-email", values);
    if (response?.status === 200) {
      // getProfile();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};

// google login
const googleLogin = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/google-auth", values);
    if (response?.status === 200) {
      let profile = await getProfile(true, response?.data?.token);
      if (profile) {
        let { token, user } = response?.data;
        // console.log("user :", user);
        setCookie(token, "token");
        if (profile.user?.user?.type !== "staff") {
          // console.log("user", user);
          if (!profile?.user?.business) {
            navigate("/signup");
            // navigate("/selectprice");
          } else if (profile.user.business && !profile.user.subscription) {
            navigate("/selectprice");
          } else {
            navigate("/home");
          }
        } else {
          navigate("/home");
        }
        // if (user?.user?.type !== "staff") {
        //   if (user?.business) {
        //     navigate("/selectprice");
        //   } else if (!user?.business) {
        //     navigate("/profile");
        //   } else if (user?.business && user?.subscription) {
        //     navigate("/home");
        //   }
        // } else navigate("/home");
        store.dispatch(_login({ token }));
      }
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

// google sign up
const googleSignup = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/decode-token", values);
    if (response?.status === 200) {
      setCookie(response?.data?.user?.token, "token");
      store.dispatch(setLoading(false));
      navigate("/profile");
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

const signUp = async (values) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/sign-up", values);
    if (response?.status === 200) {
      setCookie(response?.data?.user?.token, "token");
      store.dispatch(setLoading(false));
      // navigate("/profile");
      await swal({
        title: `Email Verification`,
        text: "Email verification link sent successfully. Please verify your email address",
        icon: "success",
        dangerMode: false,
        buttons: ["Cancel", "Ok"],
      });
      return response;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return error?.response;
  }
};

const registerBusiness = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/business", values);

    if (response?.status === 200) {
      await getProfile(true, response?.data?.token);
      store.dispatch(setLoading(false));
      return response;
      // navigate("/selectprice");
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    const duplicate = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("duplicate");
    const companyName = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("companyname");
    // console.log("erroe in sercice", error?.response?.data?.message);
    const businessEmail = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("businessemail");
    const contactPhone = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("contactphone");

    if (duplicate && companyName)
      return showError("Company name alreay in use.");
    if (duplicate && businessEmail)
      return showError("Company Email alreay in use.");
    if (duplicate && contactPhone)
      return showError("Company Number alreay in use.");
    else showError(error?.response?.data?.message, error?.response?.status);
  }
};

const forgetPassword = async (values, navigate) => {
  try {
    store.dispatch(setForgotLoading(true));
    let response = await https().post("/auth/forgotPassword", values);

    if (response?.status === 200) {
      store.dispatch(setForgotLoading(false));
      showInfo(response?.data?.message);
    }
  } catch (error) {
    store.dispatch(setForgotLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const resetPassword = async (values, navigate) => {
  try {
    store.dispatch(setResetLoading(true));
    let response = await https().post("/auth/resetPassword", values);
    if (response?.status === 200) {
      showInfo(response?.data?.message);
      removeCookie("token");
      navigate("/login");
    }
  } catch (error) {
    store.dispatch(setResetLoading(false));

    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const verifyEmail = async (values, navigate) => {
  try {
    store.dispatch(setEmailVerifyLoading(true));
    let response = await https().post("/auth/verifyEmail", values);

    // console.log("response inside verify email");

    if (response?.status === 200) {
      store.dispatch(setEmailVerifyLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setEmailVerifyLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const contactUs = async (values) => {
  try {
    store.dispatch(setContactUs(true));
    let response = await https().post("/auth/contactUs", values);

    if (response?.status === 200) {
      store.dispatch(setContactUs(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setContactUs(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const inviteContractor = async (values) => {
  try {
    let response = await https().post("/skypointContractor/invite", values);

    if (response?.status === 200) {
      showInfo(response?.data?.message);
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  login,
  googleLogin,
  googleSignup,
  signUp,
  forgetPassword,
  verifyEmail,
  resetPassword,
  registerBusiness,
  contactUs,
  setResetLoading,
  verify2fa,
  verifyTwoFactor,
  send2faCode,
  resend2fa,
  twoFactorSettings,
  staffAndProfile2fa,
  resetStaff2FA,
  selectedBusiness,
  getUserByEmail,
  inviteContractor,
};
